/**
 * SEO Helper - Manages meta tags via direct DOM manipulation
 * More reliable than react-helmet for hreflang tags
 */

const SITE_URL = 'https://bolognacityexperience.com';
const supportedLangs = ['it', 'en', 'fr', 'de', 'es', 'pt', 'ru', 'ja', 'nl', 'zh', 'ko', 'pl'];

// Add or update hreflang tags in document head
export const updateHreflangTags = (currentPath = '') => {
  // Remove existing hreflang tags
  document.querySelectorAll('link[rel="alternate"][hreflang]').forEach(el => el.remove());
  
  // Clean path (remove language prefix if present)
  let cleanPath = currentPath;
  supportedLangs.forEach(lang => {
    if (cleanPath.startsWith(`/${lang}/`) || cleanPath === `/${lang}`) {
      cleanPath = cleanPath.replace(`/${lang}`, '');
    }
  });
  if (cleanPath === '' || cleanPath === '/') cleanPath = '';
  
  // Add hreflang for each language
  supportedLangs.forEach(lang => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'alternate');
    link.setAttribute('hreflang', lang);
    link.setAttribute('href', `${SITE_URL}/${lang}${cleanPath}`);
    document.head.appendChild(link);
  });
  
  // Add x-default (Italian)
  const defaultLink = document.createElement('link');
  defaultLink.setAttribute('rel', 'alternate');
  defaultLink.setAttribute('hreflang', 'x-default');
  defaultLink.setAttribute('href', `${SITE_URL}/it${cleanPath}`);
  document.head.appendChild(defaultLink);
};

// Update OpenGraph and meta tags
export const updateMetaTags = ({ title, description, image, url, locale }) => {
  // Update title
  if (title) {
    document.title = title;
    updateMeta('og:title', title);
    updateMeta('twitter:title', title);
  }
  
  // Update description
  if (description) {
    updateMeta('description', description, 'name');
    updateMeta('og:description', description);
    updateMeta('twitter:description', description);
  }
  
  // Update image
  if (image) {
    updateMeta('og:image', image);
    updateMeta('twitter:image', image);
  }
  
  // Update URL
  if (url) {
    updateMeta('og:url', url);
    updateCanonical(url);
  }
  
  // Update locale
  if (locale) {
    updateMeta('og:locale', locale);
    document.documentElement.lang = locale.split('_')[0];
  }
};

// Helper to update/create meta tag
const updateMeta = (name, content, type = 'property') => {
  let meta = document.querySelector(`meta[${type}="${name}"]`);
  if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(type, name);
    document.head.appendChild(meta);
  }
  meta.content = content;
};

// Helper to update canonical link
const updateCanonical = (url) => {
  let canonical = document.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = url;
};

export default { updateHreflangTags, updateMetaTags };
